import React from 'react';

const CustomButton = ({ label = "", className = "", link }) => {
  return (
    <a href={link}>
      <button
      className={`text-[32px] tracking-[2px] font1 py-3 px-8 bg-teal-500 border-4 border-black rounded-xl text-black font-bold shadow-[5px_5px_0_0_rgba(20,241,149,0.8)] transition-transform transform hover:translate-x-1 hover:-translate-y-1 ${className}`}
    >
      {label}
    </button>
    </a>
  );
};

export default CustomButton;